import { render, staticRenderFns } from "./PurchaseOrderOverview.vue?vue&type=template&id=7523389d&scoped=true"
import script from "./PurchaseOrderOverview.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderOverview.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderOverview.vue?vue&type=style&index=0&id=7523389d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7523389d",
  null
  
)

export default component.exports